export const handleDownloadWithBlob = async (blob: Blob) => {
  try {
    if (blob) {
      const downloadElement = document.createElement('a');
      const url = URL.createObjectURL(blob);

      downloadElement.href = url;
      downloadElement.download = 'Invoices.zip';
      document.body.appendChild(downloadElement);
      downloadElement.click();
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Error downloading invoices:', error);
  }
};

export const downloadFromUrl = async (preSignedUrl: string, filename: string) => {
  try {
    const downloadElement = document.createElement('a');

    downloadElement.href = preSignedUrl;
    downloadElement.download = filename;
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
  } catch {
    alert('Download failed. Try later.');
  }
};
